import {
	FacilityMaintenanceContact,
	FacilityMaintenanceWorkOrder,
	Model
} from ".";

export default class Location extends Model {
	get singularNoun() {
		return "location";
	}

	get mutations() {
		return {
			contacts: FacilityMaintenanceContact,
			workOrder: FacilityMaintenanceWorkOrder
		};
	}

	resource() {
		return "locations";
	}
}
